module.exports = __webpack_public_path__ + "media/images/v2/jaas-logo-35ad3d15cdd950e0883b73af67b28904.svg";